<template>
  <fragment>
    <AppBody
      title="Pessoas / Ponto de Venda"
      subtitle="Ponto de Venda"
      :actions="actions"
    >
      <v-form
        @submit.prevent="$pointOfSale.pointOfSaleFilter()"
        class="search-forms"
      >
        <v-row>
          <v-col cols="3">
            <label class="input-labels">Nome do Representante</label>
            <v-text-field
              solo
              placeholder="Insira o nome"
              v-model="$pointOfSale.filter.nome"
              type="text"
              data-cy="representante"
              class="textinput"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels">CPF</label>
            <v-text-field
              solo
              placeholder="Insira o nº do CPF"
              v-model="$pointOfSale.filter.cpf"
              type="text"
              data-cy="cpf"
              class="textinput"
              v-mask="['###.###.###-##']"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels">CNPJ</label>
            <v-text-field
              solo
              placeholder="Insira o nº do CNPJ"
              v-model="$pointOfSale.filter.cnpj"
              type="text"
              data-cy="cnpj"
              class="textinput"
              v-mask="['##.###.###/####-##']"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels">Status</label>
            <v-select
              height="48"
              :items="$pointOfSale.status_pdv"
              @click:clear="$pointOfSale.filter.status = ''"
              clearable
              clear-icon="mdi-close-circle-outline"
              dense
              solo
              data-cy="status"
              class="textinput"
              v-model="$pointOfSale.filter.status"
              item-text="value"
              item-value="key"
              placeholder="Selecione o status"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <label class="input-labels">Tipo de pessoa</label>
            <v-select
              height="48"
              :items="tipo_pessoa"
              dense
              solo
              data-cy="pessoa"
              class="textinput"
              v-model="$pointOfSale.filter.tipoPessoa"
              placeholder="Selecione o tipo de pessoa"
              :color="$config.dados.corinputs"
              clearable
              clear-icon="mdi-close-circle-outline"
              @click:clear-icon="clearFilterFields('status')"
            >
            </v-select>
          </v-col>
          <v-col cols="3">
            <label class="input-labels">Data da inclusão (inicial)</label>
            <v-text-field
              v-model="$pointOfSale.filter.dataInicio"
              append-icon="mdi-calendar-blank-outline"
              solo
              data-cy="data-inicial"
              class="textinput"
              v-mask="['##/##/####']"
              placeholder="dd/mm/aaaa"
              :color="$config.dados.corinputs"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels">Data da inclusão (final)</label>
            <v-text-field
              v-model="$pointOfSale.filter.dataFim"
              append-icon="mdi-calendar-blank-outline"
              solo
              data-cy="data-final"
              class="textinput"
              v-mask="['##/##/####']"
              placeholder="dd/mm/aaaa"
              :color="$config.dados.corinputs"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels">E-mail</label>
            <v-text-field
              solo
              placeholder="Insira o e-mail"
              v-model="$pointOfSale.filter.email"
              type="text"
              data-cy="email"
              class="textinput"
            >
            </v-text-field>
          </v-col>
          <v-col cols="2" class="ml-auto align-self-end">
            <v-btn
              height="48"
              data-cy="filtrar"
              class="button btn-size btn-border"
              :loading="$pointOfSale.filterLoading"
              type="submit"
            >
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
        class="table-body"
        no-data-text="Não há registro de Pontos de Venda."
        loading-text="Buscando informações..."
        :loading="$pointOfSale.loading"
        :headers="headers"
        :items="orderedData"
        :items-per-page="10"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: 'Pontos de Venda por página:',
        }"
      >
        <template v-slot:item.representante_nome="{ item }">
          {{
            item.representante_nome
              ? item.representante_nome
              : item.razao_social
          }}
        </template>
        <template v-slot:item.ins_dthr="{ item }">
          {{ item.ins_dthr | data_pt_br }}
        </template>
        <template v-slot:item.tipo_pessoa="{ item }">
          {{ item.tipo_pessoa ? item.tipo_pessoa : "-" }}
        </template>
        <template v-slot:item.representante_cpf="{ item }">
          {{
            item.tipo_pessoa === "FISICA" ? item.representante_cpf : item.cnpj
          }}
        </template>
        <template v-slot:item.actions="{ item }" class="table-actions">
          <div style="display: flex; justify-content: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  icon
                  :loading="item.edit_button_loading"
                  v-bind="attrs"
                  v-on="on"
                  @click="goToPDV('editar', item)"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </AppBody>
    <ModalConfirmacao
      :textModal="$pointOfSale.text"
      @callback="$pointOfSale.removeTrigger"
    />
    <!-- <ModalOnBoarding/> -->
  </fragment>
</template>

<script>
import PDVmixins from "@/mixins/PDV.mixins.js";
import _ from "lodash";
export default {
  name: "SalesPoint",
  metaInfo: {
    title: "Vendas/Pontos de Venda | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Vendas/Pontos de Venda | ElevenTickets",
      },
    ],
  },
  mixins: [PDVmixins],
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    ModalConfirmacao: () => import("@/components/global/modal-confirmacao.vue"),
  },
  data() {
    return {
      actions: [
        {
          name: "Novo Ponto de Venda",
          action: () => this.goToPDV("new", ""),
        },
        // { name: 'Onboarding PDV', action: () => this.openModal('modal-body-pdv-onboarding', 'new', '') }
      ],
    };
  },
  computed: {
    orderedData() {
      return _.orderBy(
        this.$pointOfSale.pontos_de_venda,
        ["status", "cadastro"],
        ["asc", "desc"]
      );
    },
  },
  methods: {
    clearFilterFields(field) {
      switch (field) {
        case "status":
          this.$pointOfSale.filter.status = "";
          break;
        case "tipo_pessoa":
          this.$pointOfSale.filter.tipoPessoa = "";
          break;
        default:
          break;
      }
    },
    openModal(name) {
      document.getElementsByClassName(name)[0].style.display = "flex";
    },
  },
  mounted() {
    this.$pointOfSale.getPointsOfSale();
    this.$pointOfSale.getPointOfSaleStatus();
  },
};
</script>

<style scoped>
.pessoas-ponto-de-venda-button02 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
</style>
